import { Row } from '../Grid'

function Nav({ children }) {
  return <Row className="navbar">{children}</Row>
}

export default Nav
